import React, { useState, useEffect } from "react";
import { Progress } from "antd";

const ProgressBar = ({ forceComplete }) => {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    let intervalId;

    if (!forceComplete) {
      intervalId = setInterval(() => {
        // Increment the progress by a certain amount
        setPercent((prevPercent) => prevPercent + 1);

        // If progress reaches 100%, clear the interval
        if (percent >= 100) {
          clearInterval(intervalId);
        }
      }, (5 * 60 * 1000) / 100); // 5 minutes in milliseconds, divided by 100 for 1% intervals
    } else {
      // Force completion after 5 minutes
      setPercent(100);
    }

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [percent, forceComplete]);

  return <Progress strokeColor={{
        from: '#108ee9',
        to: '#87d068',
      }} percent={percent} status="active" />;
};

export default ProgressBar;
